module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-bottom"
  }, [_c('div', {
    staticClass: "box-bottom-div"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goAgreement(1)
      }
    }
  }, [_vm._v("用户协议")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.goAgreement(2)
      }
    }
  }, [_vm._v("隐私协议")])]), _vm._v(" "), _c('div', {
    staticClass: "box-bottom-div"
  }, [_vm._v("应用 App 名称：Link语音 App 版本：V1.0")]), _vm._v(" "), _c('div', {
    staticClass: "box-bottom-div"
  }, [_vm._v("公司名称：文安县宸链网络科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "box-bottom-div"
  }, [_vm._v("联系电话：17692639089")]), _vm._v(" "), _c('div', {
    staticClass: "box-bottom-div"
  }, [_vm._v("地址：河北省廊坊市文安县苏桥镇团结村苏桥鱼馆西50米")]), _vm._v(" "), _c('div', {
    staticClass: "box-bottom-div"
  }, [_vm._v("备案信息：冀ICP备2026010770号-1")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-top"
  }, [_c('div', {
    staticClass: "box-top-container"
  }, [_c('div', {
    staticClass: "box-top-container-left animate-item left-item"
  }, [_c('img', {
    staticClass: "box-top-container-left-img",
    attrs: {
      "src": require("../assets/images/link_logo@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-top-container-left-div"
  }, [_c('div', {
    staticClass: "box-top-container-left-div-text"
  }, [_c('span', [_vm._v("Link语音是一个专注于声音社交的互动平台，")]), _vm._v(" "), _c('span', [_vm._v("主打“用声音连接彼此”的理念。")]), _vm._v(" "), _c('span', [_vm._v("在这里，你可以卸下现实身份的包袱，无需露脸，")]), _vm._v(" "), _c('span', [_vm._v("仅凭声音与来自五湖四海的朋友进行真诚、有趣的交流。")])])])]), _vm._v(" "), _c('img', {
    staticClass: "box-top-container-img animate-item right-item",
    attrs: {
      "src": require("../assets/images/img@2x.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-885bc794"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 625
// module chunks = 1